import { useEffect, useState } from 'react'
import './House.css'
import { useParams } from 'react-router-dom'
import RoomSlider from '../../component/RoomSlider'
import { Api } from '../../Api/Api'
import { toast } from "react-toastify";
import Img from '../../component/Img'

const House = () => {

  const { id } = useParams()
  const [oneHouse, setOneHouse] = useState()

  useEffect(() => {
    loadData()
    window.scrollTo(0, 0)
  }, [])

  let loadData = () => {
    fetch(`${Api}/house/${id}`).then(res => {
      return res.json();
    }).then(res => {
      setOneHouse(res)

    }).catch((err) => {
      toast.error('Failed :' + err.message);
    });
  }
  return (
    <div className='container singleHouse'>
      {oneHouse ?
        <>
          <div className='oneHouse'>
            <div className="house-l">
              <div className="blur blur1"></div>
              <div className="blur blur2"></div>
              <Img src={`${Api}/assets/images/${oneHouse.file}`} loading='lazy' alt={oneHouse.file} />
            </div>

            <div className="house-r">
              <p>{oneHouse.description}</p>
            </div>
          </div>

          <div className="slider">
            <RoomSlider />
          </div>
          <button>Contact Us</button>

        </> : <div className="loading"></div>
      }


    </div>
  )
}

export default House
